import { useUser } from '@/pages/enterprise/user-provider'
import ContactCard from './billing-contact-card'

export default function BillingContactsBody() {
  const { billingContacts } = useUser()
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 2xl:grid-cols-3 gap-8 text-sm">
      {billingContacts.map((contact) => (
        <ContactCard
          billingContact={contact}
          billingContacts={billingContacts}
        />
      ))}
    </div>
  )
}
